import InputSelect from "global/InputSelect/InputSelect";
import { Pagination } from "react-pagination-bar";
import "react-pagination-bar/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Actionpage,
  ActionpageSize,
} from "../../redux/PaginationAction/PaginationAction";
const Paginations = ({
  pageData,
  itemsPerPage,
  onPaginate,
  haschangePageSize,
}: any) => {
  interface IRootState {
    paginate: {
      paginate: number;
    };
  }

  const { pageNumbers, fixedPageNumbers, pageSize }: any =
    useSelector<IRootState>((state) => state.paginate);

  const dispatch = useDispatch();
  const options = [
    { id: 10, text: "10" },
    { id: 20, text: "20" },
    { id: 50, text: "50" },
    { id: 100, text: "100" },
  ];

  
 
  return (
    <div className="Pagination flex  justify-center items-center">
      <Pagination
        // onlyPageNumbers={true}
        currentPage={
          fixedPageNumbers > pageNumbers ? fixedPageNumbers : pageNumbers
        }
        itemsPerPage={pageSize || 10}
        onPageChange={(pageNumber) => {
          dispatch(Actionpage(pageNumber));
          onPaginate(pageNumber);
        }}
        totalItems={pageData}
        pageNeighbours={2}
        customClassNames={{
          rpbItemClassNameActive: "pagination_style",
        }}
      />
      {haschangePageSize && pageData > 0 && (
        <InputSelect
          options={options}
          handleChange={(name, value) => {
            dispatch(ActionpageSize(value.id));
            dispatch(Actionpage(1));
          }}
          values={{ id: pageSize, text: pageSize }}
          name="pageSize"
          wrapperClassName="mt-6 w-[5rem]  "
        />
      )}
    </div>
  );
};

export default Paginations;
